<!-- performance all in one file component, для Core.notice() -->
<script lang="ts">
export { show } from './utils';
</script>

<script setup lang="ts">
import type { Item } from './utils';
import { itemById } from './utils';

import type { Props } from './types';
import TopNoticeItem from './item/item.vue';

defineProps<Props>();

const onCloseItem = (item: Item) => {
	item.onClose?.();

	itemById.delete(item.id);
};
</script>

<template>
	<teleport to="body">
		<div class="top-notice">
			<TopNoticeItem
				v-for="[_index, item] in itemById"
				:key="item.id"
				:id="item.id"
				:title="item.title"
				:text="item.text"
				:style="item.style"
				:buttonProps="item.buttonProps"
				:buttonsProps="item.buttonsProps"
				:metaText="item.metaText"
				:isSafeHTML="item.isSafeHTML"
				:forceClosed="item.forceClosed"
				:hightlight="item.hightlight"
				@close="onCloseItem(item)"
			/>
		</div>
	</teleport>
</template>

<style>
:root {
	--top-notice-top: var(--top-padding-4);
	--top-notice-right: var(--top-padding-4);
}

.top-notice {
	width: 400px;
	font-size: 14px;
	position: fixed; top: var(--top-notice-top); right: var(--top-notice-right);
	z-index: 1000010;
	display: flex; flex-direction: column-reverse; gap: var(--top-gap-2);
}

.top-notice ul {
	padding: 0 0 0 var(--top-padding-5);
}

@media only screen and (max-width: 600px) {
	:root {
		--top-notice-top: var(--top-padding-4);
		--top-notice-right: var(--top-padding-4);
	}

	.top-notice { width: auto; left: var(--top-notice-right); }
}
</style>
